<template>
  <b-modal centered id="select-sale-dialog">
    <template #modal-header="{ close }">
      <h5 class="modal-title">Gán nhân viên</h5>
      <button type="button" class="close" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Tên/Email/Số điện thoại</label>
      <div class="col-sm-7">
        <input
          type="text"
          v-model.trim="search.textSearch"
          @change="getListSale()"
          class="form-control"
        />
      </div>
      <button class="btn btn-success btn-primary" @click="getListSale()">Tìm kiếm</button>
    </div>
    <b-table
      ref="select-sale-table"
      style="max-height: 55vh"
      :fields="fields"
      :busy.sync="loading"
      sticky-header
      responsive
      hover
      bordered
      selectable
      select-mode="single"
      :items="dataList"
      @row-selected="onRowSelected"
      :per-page="search.limit"
      :current-page="search.page"
    >
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template #table-busy>
        <div class="my-2 text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
    </b-table>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="dataList.length"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
    <template #modal-footer="{ close }">
      <button :disabled="disabled" class="btn btn-light" @click="submitSale(close)">
        Xác nhận
      </button>
    </template>
  </b-modal>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  export default {
    data() {
      return {
        fields: [
          {
            key: 'selected',
            label: '',
            tdClass: 'text-center',
            thStyle: 'min-width: 35px',
          },
          {
            label: 'Tên sale',
            key: 'name',
            thStyle: { 'min-width': '140px', 'word-break': 'break-word' },
          },
          { label: 'Email', key: 'userName' },
          { label: 'Tỉnh/Thành phố', key: 'provinceName' },
        ],
        dataList: [],
        search: {
          limit: 20,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        loading: false,
        disabled: true,
        selected: null,
      }
    },

    watch: {
      'search.page': function () {
        this.getListSale()
      },
    },

    created() {
      this.getListSale()
    },

    methods: {
      onRowSelected(items) {
        this.disabled = !(items.length > 0)
        this.selected = items.length > 0 ? items[0] : null
        this.$emit('selectSale', this.selected)
        this.$bvModal.hide('select-sale-dialog')
      },
      async getListSale() {
        try {
          this.loading = true
          if (this.search.textSearch === '') delete this.search.textSearch
          const response = await StaffService.getListLowerGrade(this.search)
          if (response.code === 1000) {
            this.dataList = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped></style>
